(function () {
  const snowContainer = document.createElement("div");
  snowContainer.id = "snow-container";
  document.body.appendChild(snowContainer);

  for (let i = 0; i < 40; i++) {
    let snow = document.createElement("div");
    snow.className = "snowflake";
    snow.style.left = Math.random() * 100 + "vw";
    snow.style.animationDuration = 5 + Math.random() * 5 + "s";
    snow.style.opacity = Math.random();
    snow.style.fontSize = 10 + Math.random() * 10 + "px";
    snowContainer.appendChild(snow);
  }
})();
